import React from 'react';

export default function Footer() {
  return (
    <div>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Sanema Tour</h4>
              <a className="btn btn-link" href="/About">
                Tentang Kami
              </a>
              <a className="btn btn-link" href="/PaketPerjalanan">
                Paket Perjalanan
              </a>
              <a className="btn btn-link" href="/Artikel">
                Artikel
              </a>
              <a className="btn btn-link" href="/Contact">
                Kontak Kami
              </a>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Kontak</h4>
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-3" />
                Jl. Jakarta No.12, Karangpawitan, Karawang Barat, Jawa Barat,
                Indonesia, 41315
              </p>
              <p className="mb-2">
                <i className="fa fa-phone-alt me-3" />
                0811 8810 491
              </p>
              <p className="mb-2">
                <i className="fa fa-envelope me-3" />
                sanematour@gmail.com
              </p>
              <div className="d-flex pt-2">
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://www.instagram.com/sanematour?igsh=YnlnOG41a3l0b3V5"
                >
                  <i className="fab fa-instagram" />
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://web.facebook.com/sanema.sji?mibextid=ZbWKwL&_rdc=1&_rdr#"
                >
                  <i className="fab fa-facebook-f" />
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://www.tiktok.com/@sanematour?_t=8o5ZZ5FHpkQ&_r=1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    width="60"
                    height="60"
                    className="svg-icon"
                  >
                    <path
                      className="icon-path"
                      fill="white"
                      d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"
                    />
                  </svg>
                </a>

                <a
                  className="btn btn-outline-light btn-social"
                  href="https://www.youtube.com/@sanematour?si=wHOPQjdhTXsNtrB8"
                >
                  <i className="fab fa-youtube" />
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Galeri</h4>
              <div className="row g-2 pt-2">
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1 square-image"
                    src="assets/img/galeri-1.jpeg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1 square-image"
                    src="assets/img/galeri-2.jpeg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1 square-image"
                    src="assets/img/galeri-3.jpeg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1 square-image"
                    src="assets/img/galeri-4.jpeg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1 square-image"
                    src="assets/img/galeri-5.jpeg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1 square-image"
                    src="assets/img/galeri-6.JPG"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Artikel</h4>
              <p>Update berita terbaru dari kami</p>
              <div
                className="position-relative mx-auto"
                style={{ maxWidth: 400 }}
              >
                <input
                  className="form-control border-primary w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Email"
                />
                <button
                  type="button"
                  className="btn btn-primary py-2 top-0 end-0 mt-2"
                >
                  Daftar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                ©{' '}
                <a className="border-bottom stabilo1" href="/">
                  Sanema Tour
                </a>
                , All Right Reserved. Designed By{' '}
                <a
                  className="border-bottom"
                  href="https://www.instagram.com/portfolio.reza/"
                  style={{
                    color: 'white',
                    fontWeight: 'lighter',
                    backgroundColor: 'rgba(255, 255, 0, 0.3)',
                  }}
                >
                  Rizqi Reza Ardiansyah {' '}{new Date().getFullYear()}
                </a> 
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}
    </div>
  );
}
